import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import Lib from 'library'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.css'

const InfluencerResign = () => {

	const App = useApp()
	const navigate = useNavigate()


	const [resignValue, setResignValue] = useState('') // 취소 사유
	const [textValue, setTextValue] = useState('') // 기타 텍스트 내용
	const [otherDisable, setOtherDisable] = useState(true) // Radio 상태

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	// 라디오 선택시 동작
	const onChange = (e) => {
		setResignValue(e.target.id);
		if (e.target.id === '05') {
			setOtherDisable(false)
		} else {
			setOtherDisable(true)
			setTextValue('')
		}
	}

	// 기타 사유 텍스트
	const onTextChange = (e) => {
		setTextValue(e.target.value);
	}

	// 인플루언서 서비스 철회하기,철회하고 메인 페이지로 이동
	const onResign = () => {
		if (textValue === '' && resignValue === ''){
			App.toast('서비스 철회사유 선택해주세요')
			return false
		} 
		if (resignValue === '05' && textValue === ''){
			App.toast('기타 사유를 입력해주세요')
			return false
		} 
		Lib.post(`/api/infl/wthdr`, {
			wthdrCd: resignValue,
			wthdrRsn: textValue
		}, () => {
			App.toast("금융인플루언서 서비스가 철회되었습니다.")
			navigate("/home")
		})
	}

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding">
						<h3>인플루언서 이용에 불편함이 있으셨나요?</h3>
						<div className="mt_20" style={{ color: "#666", lineHeight: "2rem" }}>
							<p>인플루언서 서비스 철회 시 모든 활동내역이 삭제되며,<br />복구할 수 없습니다.</p>
							<p className="mt_15">연결된 데이터는 해제되지 않으며 또한 모니 앱서비스<br />에서도 탈퇴되지 않습니다.</p>
						</div>
					</div>
				</div>
				<div className="padding">
					<h4>서비스를 철회하는 이유가 무엇인가요?</h4>
					<ul className="resign-list mt_30">
						<li>
							<div className="chk">
								<input type="radio" onChange={onChange} id="01" name="resign" />
								<label htmlFor="01">
									<span>인플루언서를 그만하고 싶어서</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" onChange={onChange} id="02" name="resign" />
								<label htmlFor="02">
									<span>이용에 불편하고 장애가 많아서</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" onChange={onChange} id="03" name="resign" />
								<label htmlFor="03">
									<span>사용빈도가 낮아서</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" onChange={onChange} id="04" name="resign" />
								<label htmlFor="04">
									<span>재가입을 위해</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" onChange={onChange} id="05" name="resign" />
								<label htmlFor="05">
									<span>기타</span>
								</label>
							</div>
						</li>
					</ul>
					<textarea disabled={otherDisable} onChange={onTextChange} value={textValue} placeholder="기타 사유를 입력해주세요." className="write-area mt_10" style={{ minHeight: "8rem" }} />
				</div>
			</div>
			<div className="flex_shrink_0 padding" onClick={onResign}>
				<Button className="btn btn--big">인플루언서 서비스 철회하기</Button>
			</div>
		</div>
	)
}

export default InfluencerResign
